import emailEditorDefaults from '~/src/definitions/EmailEditorDefaults'

const defaultProps = {
  visible: {
    type: Boolean,
    default: true
  }
}

export default {
  props: defaultProps,
  inject: ['eventBus'],
  computed: {
    defaultIconSizeStyle () {
      return { fontSize: this.dataSiteDefaults.site.icons.defaultSize}
    },
    defaultIconSize () {
      return this.dataSiteDefaults.site.icons.defaultSize;
    }
  },
  data () {
    return {
      dataSiteDefaults: emailEditorDefaults,
      dataVisible: this.visible
    }
  }
}

export const props = defaultProps
